export const GET_BILLS = "GET_BILLS";

export const GET_BILL = "GET_BILL";

export const ADD_BILL = "ADD_BILL";

export const UPDATE_BILL = "UPDATE_BILL";

export const DELETE_BILL = "DELETE_BILL";

export const GET_CAT_BILLS = "GET_CAT_BILLS";




// WEBPACK FOOTER //
// ./src/actions/types.js